import { FT, Spine } from 'ft'

const $SPINE_YI = 'spine.YI'
const $SPINE_MD = 'spine.MD'
const $SPINE_NEEKO = 'spine.Neeko'
const $SPINE_AKL = 'spine.AKL'
const $SPINE_LS = 'spine.LS'
const $SPINE_SLK = 'spine.SLK'
const $soundHeroDown = 'sound.hero-down'

FT.rm.addSpine($SPINE_YI)
FT.rm.addSpine($SPINE_MD)
FT.rm.addSpine($SPINE_NEEKO)
FT.rm.addSpine($SPINE_AKL)
FT.rm.addSpine($SPINE_LS)
FT.rm.addSpine($SPINE_SLK)
FT.rm.addSound($soundHeroDown)

const map = {
  yi: $SPINE_YI,
  md: $SPINE_MD,
  neeko: $SPINE_NEEKO,
  akl: $SPINE_AKL,
  ls: $SPINE_LS,
  slk: $SPINE_SLK,
}

class FreezeHero extends Spine {
  constructor(heroId) {
    super(FT.rm.spine(map[heroId]))
    this.scale.set(0.5, 0.5)
    this.position.set(FT.stage.centerX, FT.stage.centerY)
    this.skeleton.setSkinByName('Freeze')
  }

  play() {
    this.state.setAnimation(0, 'SC03_Freeze_Fall')

    this.state.addListener({
      event: (_, event) => {
        const eventName = event.stringValue
        if (eventName === 'Boom') {
          const sound = FT.rm.sound($soundHeroDown)
          sound.play()
        }
      },
    })
  }
}

export default FreezeHero
